module.exports = __webpack_public_path__ + "static/add_calendar-f27a6d3bd1c773a5381f9ae3b982da29.png";